<template>
  <div class="body">
    <el-card header="附件图片列表">
      <el-row>
        <el-upload
          ref="problemProductPhotoRef"
          :class="{ hide: true }"
          accept=".jpg,.jpeg,.png,.gif,.bmp,.JPG,.JPEG,.PBG,.GIF,.BMP"
          :disabled="true"
          multiple
          list-type="picture-card"
          action="upload"
          :file-list="problemProductPhotoList"
        >
          <i class="el-icon-plus"></i>
          <div slot="file" slot-scope="{ file }" style="height: 100%">
            <img width="100%" height="100%" :src="file.url" alt="" />
            <span class="el-upload-list__item-actions">
              <span
                class="el-upload-list__item-preview"
                @click="handleProblemProductPreview(file)"
              >
                <i class="el-icon-zoom-in"></i>
              </span>
              <!-- <span
                class="el-upload-list__item-delete"
                @click="downloadFile(file)"
              >
                <i class="el-icon-download"></i>
              </span> -->
            </span>
          </div>
        </el-upload>
        <el-dialog
          :visible.sync="problemProductDialogVisible"
          class="enlargePhoto"
        >
          <img width="100%" :src="problemProductImageUrl" alt="" />
        </el-dialog>
      </el-row>
    </el-card>
  </div>
</template>

<script>
import { fileService } from "@/api/common/file-utils";
import QBRApi from "@/api/QBR/index";
import commonMethods from "@/utils/commonMethods";

export default {
  data() {
    return {
      problemProductPhotoList: [],
      problemProductDialogVisible: false,
      problemProductImageUrl: "",
    };
  },
  extends: commonMethods,
  beforeCreate() {
    document.getElementsByName("viewport")[0].content =
      "width=device-width,initial-scale=1,minimum-scale=1,maximum-scale=1,user-scalable=no";
  },
  mounted() {
    let imgs = this.$route.query.imgIds;
    if (imgs) {
      let imgsList = imgs.split(",");
      imgsList.forEach((item) => {
        let obj = {
          url: "/adminconsole/file/downloadByKey?key=" + item,
        };
        this.problemProductPhotoList.push(obj);
      });
    }
  },
  methods: {
    getImageList(val) {},
    // 查看图片
    handleProblemProductPreview(file) {
      this.problemProductImageUrl = file.url;
      this.problemProductDialogVisible = true;
    },
    //文件下载
    downloadFile(row) {
      fileService.downloadFile(row);
    },
  },
};
</script>

<style scoped>
.body {
  width: 100%;
  height: 100%;
  background: #ffffff;
}
</style>
<style lang="scss">
.hide .el-upload--picture-card {
  display: none;
}
</style>
